import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
// ngrx store
import { Store } from '@ngrx/store';
// services
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';
import { FormsModule } from '@angular/forms';
import { NotificationsComponent } from '@shared/components/notifications/notifications.component';
import { RegisterComponent } from 'app/register/components/register/register.component';
import { LanguageSelectorComponent } from '@shared/components/language-selector/language-selector.component';
import { RESET_USER_STATE } from '@shared/reducers/user.reducer';

declare var ga: any;

@Component({
  selector: 'app-register-section',
  standalone: true,
  imports: [CommonModule, FormsModule, NotificationsComponent, RegisterComponent, LanguageSelectorComponent],
  templateUrl: './register-section.component.html',
  styleUrls: ['./register-section.component.scss'],
  providers: [ErrorHandler, DataStorageService]
})
export class RegisterSectionComponent implements OnInit {

  constructor(
    private _dataStorageService: DataStorageService,
    private _appStore: Store<AppState>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      ga('set', 'page', '/register');
      ga('send', 'pageview');
    }

    this._dataStorageService.removeCookie('dataID');
    this._appStore.dispatch(RESET_USER_STATE());
  }

}
